import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import locales_es from '../../../locales/es';
import { useHistory } from 'react-router-dom';
import { set } from 'react-native-reanimated';
import { api, helpers } from "../../../import";
import {Colors, Routes} from '../../../configs';
import AuthService from '../../../modules/authService';
import { showModalInfo } from '../../../modules/ViewHelpers';

interface RouteParams {
    code?: string;

}

const useVerificateCodeEmail = () => {
    const auth = new AuthService();
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const {code}:RouteParams = useParams<RouteParams>();
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState('');
    const [route, setRoute] = useState(``);

    
    const emailSuccess = (res: any) => {
        auth    
         .saveUserData(res.data);
        auth
         .setHeaderInOrderOfUserStatus();
        setLoading(false);
    }
    const validatorData = (res: any) =>{
        if(!res.name || !res.lastname || !res.professional_prefix_id){
            setRoute(`/${Routes.SignUpSuccessful}`)
        } else {
            setRoute(`/${Routes.Home}`)

        }
            
    }

    const onPressContinue = () => {
        if (loading == true) {
            return;
        }
        
        history.replace(route);
    }


    useEffect(() => {

        setLoading(true);
        api
         .emailValidation(code)
            .then((res: any) => {
                validatorData(res.data.user);
                emailSuccess(res);
                setMessage(res.message);
                setSuccess(true);
                localStorage.removeItem('emailToValidate');
            })
            .catch((err) => {
                showModalInfo(locales_es.attention, helpers.getErrorMsg(err));
                setLoading(false);
                history.push('/login');
            })
    }, []);
    


    return {
        loading,
        success,
        message,
        onPressContinue
    }
}
 
export default useVerificateCodeEmail;